// @ts-check
import React, { useEffect, useState } from "react"
import Modal from "../../atoms/Modal.atom"
import PropTypes, { element } from "prop-types"
import { useMessage } from "../../../hooks/useMessage.hook"
import { messages } from "../../../consts/common.const"
import { Message } from "../../atoms/Message.atom"
import PrimaryButton from "../../molecules/buttons/PrimaryButton.molecule"
import SecondaryButton from "../../molecules/buttons/SecondaryButton.molecule"

/** @type {import("./ModalForm.compunds")["ModalForm"]} */
export default function ModalForm({
  children,
  className = "",
  closable = false,
  loading = false,
  saveLabelIcon = "pi-check",
  cleanUp,
  externalMessageError,
  service,
  postSubmit,
  setVisible,
  onSave,
  footerChildren,
  saveLabel,
  disabledSaveBtn,
  saveLabelClassName,
  withoutHeader,
  withoutFooter,
  header,
  visible,
  dismissableMask,
  footer,
  headerIconClass,
  headerTitle,
  headerIcon,
  headerSubtitle,
  showInlineErrorMessage = true,
}) {
  const { ref, setErrorMessage } = useMessage()
  const [disabled, setDisabled] = useState(false)

  useEffect(() => {
    const mounted = true

    if (mounted) {
      if (externalMessageError && showInlineErrorMessage) {
        setErrorMessage({ summary: externalMessageError })
      }
    }
  })

  async function handleSubmit() {
    setDisabled(true)
    const response = await service()
    // console.log('response modal', response)
    if (response === null || response === undefined) {
      setDisabled(false)
      return null
    }
    if (response.success) {
      if (postSubmit) {
        postSubmit(response.result)
      }
      setVisible(false)
      setDisabled(false)
    } else {
      const { errorMessage, message } = response
      if (showInlineErrorMessage && ref.current) {
        setErrorMessage({
          summary: errorMessage || message || messages.dataDoesNotLoad.details,
        })
        setDisabled(false)
      } else {
        setDisabled(false)
      }
    }
  }

  // Revisar bug visual
  const onHideHandler = () => {
    setVisible(false)
    return cleanUp ? cleanUp() : null
  }
  const handleSave = onSave || handleSubmit

  const defaultFooter = (
    <div>
      <SecondaryButton
        rounded
        icon="pi pi-times"
        label="Cancelar"
        onClick={onHideHandler}
        disabled={disabled}
      />
      {footerChildren && footerChildren}
      {/* eslint-disable-next-line */}
      <PrimaryButton
        rounded
        icon={`pi ${loading ? "pi-spin pi-spinner" : saveLabelIcon}`}
        label={saveLabel || "Guardar"}
        onClick={handleSave}
        disabled={disabled || disabledSaveBtn || loading}
        className={`mr-0 ${saveLabelClassName}`}
      />
    </div>
  )
  return (
    <>
      <Modal
        header={() => {
          if (withoutHeader) {
            return null
          }
          if (header) {
            return header
          }
          if (headerIconClass || headerIcon || headerTitle) {
            return (
              <div className="flex gap-3 align-items-center modal-header">
                {headerIcon || (
                  <i
                    className={`${headerIconClass} text-4xl modal-header-icon`}
                  />
                )}
                <div className="flex flex-column">
                  <span className="text-3xl font-semibold font-cairo modal-header-title">
                    {headerTitle}
                  </span>
                  {headerSubtitle && (
                    <span className="text-base font-normal font-mulish modal-header-subtitle">
                      {headerSubtitle}
                    </span>
                  )}
                </div>
              </div>
            )
          }
        }}
        visible={visible}
        breakpoints={{ "960px": "75vw" }}
        style={{ width: "50vw", maxWidth: "560px" }}
        footer={withoutFooter ? "" : footer || defaultFooter}
        onHide={onHideHandler}
        draggable={false}
        className={className}
        closable={closable}
        dismissableMask={dismissableMask}
      >
        {showInlineErrorMessage && <Message ref={ref} />}
        {children}
      </Modal>
    </>
  )
}

ModalForm.propTypes = {
  children: PropTypes.node,
  header: PropTypes.oneOfType([
    PropTypes.arrayOf(element),
    element,
    PropTypes.string,
    PropTypes.node,
    PropTypes.func,
  ]),
  cleanUp: PropTypes.func,
  footer: PropTypes.oneOfType([
    PropTypes.arrayOf(element),
    element,
    PropTypes.string,
    PropTypes.node,
    PropTypes.func,
  ]),
  visible: PropTypes.bool,
  setVisible: PropTypes.func,
  service: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
  showInlineErrorMessage: PropTypes.bool,
}
